import { useState } from "react";
import { ImagePlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Stars } from "./Stars";
import { api, errMsg } from "../../lib/api";

const field = "rounded-xl border-[#D4AF37]/25 bg-[#190317]/60 text-[#FFF8EF] placeholder:text-[#E8D8C8]/60";

export const ReviewForm = ({ open, setOpen, cat }) => {
  const [f, setF] = useState({ name: "", rating: 5, text: "" });
  const [photo, setPhoto] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.name.trim().length < 2 || f.text.trim().length < 10) {
      toast.error("Please add your name and a few words about your experience");
      return;
    }
    const fd = new FormData();
    fd.append("name", f.name.trim());
    fd.append("category", cat.slug);
    fd.append("rating", String(f.rating));
    fd.append("text", f.text.trim());
    if (photo) fd.append("photo", photo);
    setBusy(true);
    try {
      await api.post("/reviews", fd);
      toast.success("Thank you! Your review will appear once we approve it.");
      setF({ name: "", rating: 5, text: "" });
      setPhoto(null);
      setOpen(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-h-[90vh] overflow-y-auto border-[#D4AF37]/30 bg-[#240620] text-[#FFF8EF] sm:rounded-[24px]" data-testid="review-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl font-medium">Share your {cat.name} experience</DialogTitle>
          <DialogDescription className="text-[#E8D8C8]">Your review shows on this page once approved.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <Input value={f.name} onChange={(e) => setF((s) => ({ ...s, name: e.target.value }))} placeholder="Your name *" className={`h-12 ${field}`} data-testid="review-name-input" />
          <Stars value={f.rating} onChange={(v) => setF((s) => ({ ...s, rating: v }))} size={26} testId="review-rating" />
          <Textarea value={f.text} onChange={(e) => setF((s) => ({ ...s, text: e.target.value }))} placeholder="How were the flowers and the service? *" rows={4} maxLength={1000} className={field} data-testid="review-text-input" />
          <label className="flex cursor-pointer items-center gap-3 rounded-xl border border-dashed border-[#D4AF37]/35 px-4 py-3 text-sm text-[#F3E5AB]" data-testid="review-photo-label">
            <ImagePlus size={18} /> <span className="truncate">{photo ? photo.name : "Add a photo (optional)"}</span>
            <input type="file" accept="image/*" className="hidden" onChange={(e) => setPhoto(e.target.files?.[0] || null)} data-testid="review-photo-input" />
          </label>
          <button type="submit" disabled={busy} className="flex w-full items-center justify-center gap-2 rounded-full bg-gold-foil py-3.5 text-sm font-semibold text-[#240620] disabled:opacity-60" data-testid="review-submit-btn">
            {busy && <Loader2 size={15} className="animate-spin" />} Submit review
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
